import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "PDFPageFooter" }
const _hoisted_2 = { class: "PoweredBy" }
const _hoisted_3 = { class: "PageNumber" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "js-pdf-page-number" }, "X", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineSVG = _resolveComponent("InlineSVG")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InlineSVG, {
        src: require('@/assets/logo/milva-icon.svg')
      }, null, 8, ["src"]),
      _createElementVNode("span", null, _toDisplayString(_ctx.mixWB('POWERED_BY_MILVA')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.mixWB('PAGE')) + " ", 1),
      _hoisted_4
    ])
  ]))
}